import { render, staticRenderFns } from "./CL.vue?vue&type=template&id=67094f32&scoped=true&"
var script = {}
import style0 from "./CL.vue?vue&type=style&index=0&id=67094f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67094f32",
  null
  
)

export default component.exports